import React, { Component } from "react";
import MainLayout from "../mainLayout/index";
import FpgMinusIcon from "../icons/fpgminusicon";
import FpgPlusIcon from "../icons/fpgplusicon";
import DraggerIcon from "../icons/draggericon";
import CatEditIcon from "../icons/catediticon";
import TextField from "../component/TextField";
import CheckBox from "../component/CheckBox";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import commonImage from "../commonImage";
import PlusIcon from "./../icons/plusicon";

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//Validation import
import SimpleReactValidator from "simple-react-validator";

//sweet alert
import swal from "sweetalert";

//Service import
import service from "../services";
import Loader from "../component/loader";
import TablistAccessiblity from "./TablistAccessiblity";
import Tablist from "./Tablist";

// fake data generator
const getItems = (count) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    id: `item-${k}`,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

let sub;
export default class Filaccessibillity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      name: "",
      description: "",
      loaderFlag: false,
      isDraggable: false,
      changeAccessibillityTitleName: false,
      getAllAccessibilityDetails: [],
      getAllAccessibilityDocs: [],
      id: "",
      isDraggable: false,
      eventiveId:'',
      showTags:true,
      showFilters:true,
      imagePreloader: false,
      base64: "",
      isEdited: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.tablistRef = React.createRef();
  }
  AddCategory = () => {
    this.validator.hideMessages("");
    this.setState({
      addCatmodal: true,
      name: "",
      description: "",
      isEdited: true
    });
  };
  CloseModal = () => {
    this.setState({
      addCatmodal: false,
      name: "",
      description: "",
      changeAccessibillityTitleName: false,
      id: '',
      eventiveId:'',
      showTags:true,
      showFilters:true,
      base64: "",
      isEdited: false
    });
    this.validator.hideMessages("");
  };
  componentDidMount = async () => {
    this.getAllAccessibility();
    this.getaccessibility();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getaccessibility = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "film|accessibility|getRefValue":
          this.setState(
            {
              getAllAccessibilityDetails: response.data,
              getAllAccessibilityDocs: response.data.docs,
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
              if (this.tablistRef.current) this.tablistRef.current.updatedAt();
            }
          );
          break;
        case "film|accessibility|add":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                addCatmodal: false,
              },
              this.setState({
                loaderFlag: false,
                name: "",
                description: "",
              }),
              this.apiserve.success("Accessibility created successful.")
            );
          }
          this.getAllAccessibility();
          break;
        case "film|accessibility|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
          this.setState(
            {
              addCatmodal: false,
            },
            this.setState({ loaderFlag: false }),

            this.apiserve.success("Accessibility updated Successful.")
          );
          }
          this.getAllAccessibility();
          break;
        case "film|accessibility|remove":
          this.getAllAccessibility();
          break;
        case "film|accessibility|changeOrder":
          break;
      }
    });
  };

  getAllAccessibility = () => {
    this.apiserve.sendevent("film|accessibility|getRefValue", {});
  };

  onInputChange = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };

  handleChecked = (e) => {
    this.updateState({
      [e.target.name]: e.target.checked,
    });
  };

  updateState = (data, callback) => {
    this.setState({
      ...data,
      isEdited: true
    }, callback);
  }

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      if (this.state.changeAccessibillityTitleName) {
        let updateAccessibillity = {
          name: this.state.name,
          description: this.state.description,
          accessibilityId: this.state.id,
          eventiveId: this.state.eventiveId,
          showTags: this.state.showTags,
          showFilters: this.state.showFilters,
          image: this.state.base64,
        };
        this.apiserve.sendevent(
          "film|accessibility|update",
          updateAccessibillity
        );
      } else {
        let data = {
          name: this.state.name,
          description: this.state.description,
          eventiveId: this.state.eventiveId,
          showTags: this.state.showTags,
          showFilters: this.state.showFilters,
        };
        this.apiserve.sendevent("film|accessibility|add", data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  editAccessibilityUser = async (item) => {
    this.setState({
      addCatmodal: true,
      changeAccessibillityTitleName: true,
      name: item.name,
      description: item.description,
      id: item._id,
      eventiveId: item.eventiveId ? item.eventiveId : '',
      showTags: item.showTags,
      showFilters: item.showFilters,
      base64: item.image,
      isEdited: false
    });
    this.validator.hideMessages("");
  };

  deleteAccessibilityUser = async (item) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Your record has been deleted!", {
          icon: "success",
        });
        let data = {
          accessibilityId: item._id,
        };
        this.apiserve.sendevent("film|accessibility|remove", data);
      } else {
        swal("Your record is safe!");
      }
    });
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.getAllAccessibilityDocs];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        accessibilityId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    const data = { order: updateArr };
    this.apiserve.sendevent("film|accessibility|changeOrder", data);
    this.setState({ getAllAccessibilityDocs: arr });
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  onChangeFile(e) {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState(
        {
          file: file,
        },
        () =>{
          const fileList = Math.round((file && file.size / 1024));
            if (fileList >= 2048) {        
              this.setState({
                errorMsg: true,
                errorMsgShow: 'Please upload a file smaller than 2 MB'           
               })
                return false;
            }
            if(file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg' || file && file.type === 'image/svg+xml' || file && file.type === 'image/svg' || file && file.name.includes('.svg')){
              setTimeout(() => {
                  this.imageUpload(file,event.target.result);

                },0)
          }else{
            this.setState({
              errorMsg: true,
              errorMsgShow: 'Please upload a file for PNG,JPG, JPEG or SVG'           
          })
          } 
        });
    };
  }

  imageUpload = (file, img) => {
    this.setState({ imagePreloader: true });

    var fileSet= commonImage(file, false, '', img);
    fileSet.then((value) => {
      this.updateState({
        base64: value,
        imagePreloader: false,
      });
    });
  };

  render() {
    const {
      getAllAccessibilityDocs,
      changeAccessibillityTitleName,
    } = this.state;
    return (
      <React.Fragment>
          <div className="right_side_wrapper">
            <TablistAccessiblity active={0} ref={this.tablistRef} />
            <div className="cat_outer_content">
              <div className="category_add_edit">
                <div className="category_header relative">
                  <p>Film Accessibillity </p>
                  <span className="add_icon d_flex" onClick={this.AddCategory}>
                    <FpgPlusIcon
                      width="16"
                      height="16"
                      color="#ffffff"
                      stroke="#4F4F4F"
                    />
                  </span>
                </div>
                <div className="list_wrap striped_droppable_table">
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided, snapshot) => (
                        <ul
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {getAllAccessibilityDocs?.map((item, index) => (
                            <Draggable
                              key={item._id}
                              draggableId={item._id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <li
                                  className="pointer d_flex d_flex_align_center"
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <span className="cat_drag d_flex">
                                    <DraggerIcon />
                                  </span>
                                  <p className="cat_name">{item.name}</p>
                                  <div className="action d_flex d_flex_align_center">
                                    <span
                                      className="cat_edit pointer"
                                      onClick={() =>
                                        this.editAccessibilityUser(item)
                                      }
                                    >
                                      <CatEditIcon />
                                    </span>
                                    <span
                                      className="remove_cat pointer"
                                      onClick={() =>
                                        this.deleteAccessibilityUser(item)
                                      }
                                    >
                                      <FpgMinusIcon
                                        width="16"
                                        height="16"
                                        color="#4F4F4F"
                                      />
                                    </span>
                                  </div>
                                </li>
                              )}
                            </Draggable>
                          ))}
                        </ul>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
            <div
              className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
            >
              <span className="popup_overlay" onClick={this.CloseModal}></span>
              <div className="cat_modal_inner">
                <p className="cat_title text_center">
                  {changeAccessibillityTitleName
                    ? "Edit Film Accessibillity"
                    : "Film Accessibillity"}
                </p>
                <form>
                <div className="field_row horizontal_field d_flex">
                    <label>Accessibillity Icon</label>
                    <div className="cat_img_upload">
                      <div className="cat_img radius_50 absolute_loader">
                        {this.state.imagePreloader ? (
                          <Loader />
                        ) : (
                          <img
                            src={
                              this.state.base64
                                ? this.apiserve.imageUrl + this.state.base64
                                : "/images/image-placeholder.png"
                            }
                          />
                        )}

                        <div className="input_file">
                          <input
                            id="myInput"
                            type="file"
                            ref={(ref) => (this.upload = ref)}
                            style={{ display: "none" }}
                            onChange={this.onChangeFile.bind(this)}
                            accept=".png, .jpg, .jpeg, .svg"
                          />
                          <span
                            className="add_icon"
                            onClick={() => {
                              this.upload.click();
                            }}
                          >
                            <PlusIcon />
                          </span>
                        </div>
                      </div>
                    </div>
                    <span className="limit_text">2 MB Limit</span>
                  </div>
                  <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Accessibillity Name"
                      name="name"
                      value={this.state.name}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Accessibillity Name",
                        this.state.name,
                        "required"
                      )}
                    />
                    {/* <span style={{ color: "red" }}>
                    {this.validator.message(
                      "Accessibillity Name",
                      this.state.name,
                      "required"
                    )}
                  </span> */}
                  </div>
                  <div className="field_row horizontal_field d_flex">
                    <label>Accessibillity Description</label>
                    <div className="textarea_wrap">
                      <textarea
                        type="text"
                        rows="12"
                        name="description"
                        value={this.state.description}
                        onChange={this.onInputChange}
                      ></textarea>
                      <span style={{ color: "red" }}>
                        {this.validator.message(
                          "Description",
                          this.state.description,
                          "required"
                        )}
                      </span>
                    </div>
                  </div>
                  {  
                  <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Eventive ID"
                      name="eventiveId"
                      value={this.state.eventiveId}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Eventive ID",
                        this.state.eventiveId,
                        "required"
                      )}
                      // disable={this.state.changeAccessibillityTitleName ? false : true}
                    />
                  </div>}
                  <div className="field_row">
                    <CheckBox
                      label="Include In Tags"
                      type="checkbox"
                      id="showTags"
                      name="showTags"
                      checked={this.state.showTags}
                      onChange={(e) => this.handleChecked(e)}
                    />
                  </div>
                  <div className="field_row">
                    <CheckBox
                      label="Include In Filters"
                      type="checkbox"
                      id="showFilters"
                      name="showFilters"
                      checked={this.state.showFilters}
                      onChange={(e) => this.handleChecked(e)}
                    />
                  </div>
                  <div className="cat_btns text_center ">
                    <button type="button" onClick={this.CloseModal}>
                      CANCEL
                    </button>
                    <button
                      className={this.state.changeAccessibillityTitleName && !this.state.isEdited ? "disabled" : "active"}
                      disabled={this.state.changeAccessibillityTitleName && !this.state.isEdited}
                      onClick={(e) => this.submitFn(e)}
                    >
                      SAVE
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}
